<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.carrySettlements'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.title"
            :placeholder="$t('settlement.title')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.clientName"
            :placeholder="$t('delivery.sender')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        :loading="loading"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="title"
          :title="$t('settlement.title')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="showRow(row)">{{ row.title }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="clientName"
          :title="$t('delivery.sender')"
          min-width="80"
        >
        </vxe-table-column>
        <vxe-table-column
          field="amount"
          :title="$t('settlement.amount')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.amount | currency }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="deliveryQuantity"
          :title="$t('settlement.totalQuantity')"
          min-width="80"
        />
        <vxe-table-column
          field="settlerName"
          :title="$t('settlement.settlerNameDelivery')"
          min-width="80"
        />
        <vxe-table-column
          field="settleAt"
          :title="$t('text.createAt')"
          min-width="80"
        />
        <vxe-table-column
          field="payoffAt"
          :title="$t('settlement.payoffAtDelivery')"
          min-width="80"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="150">
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="row.payoffAt == null"
              type="text"
              size="mini"
              @click="edit(row, rowIndex)"
              >{{ $t("text.edit") }}</el-button
            >
            <el-button
              v-if="row.payoffAt == null"
              type="text"
              size="mini"
              @click="deleteRow(row)"
              >{{ $t("text.delete") }}</el-button
            >
            <el-button
              v-if="row.payoffAt == null"
              type="text"
              size="mini"
              @click="confirmPayOff(row, rowIndex)"
              >{{ $t("action.paymentOff") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('rules.edit', [$t('settlement.title')])"
      :visible.sync="editDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="60px">
        <el-form-item
          :label="$t('settlement.title')"
          :prop="'title'"
          :rules="[
            { required: true, validator: validateTitleEdit, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.title" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :visible.sync="addDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('delivery.sender')"
              :prop="'sender'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('delivery.sender')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="addObj.sender"
                @blur="blurSender"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('settlement.title')"
              :prop="'title'"
              :rules="[
                { required: true, validator: validateTitle, trigger: 'blur' },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.title" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('delivery.deliverAt')"
              :prop="'_date'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('delivery.deliverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="addObj._date"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('text.startAt')"
                :end-placeholder="$t('text.startAt')"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils";
import Show from "./show";
import DeliverySettlement from "@/api/deliverySettlement.js";
import Courier from "@/api/courier.js";
import Delivery from "@/api/delivery.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Show,
  },
  data() {
    var validateTitleEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("settlement.title")]))
        );
        return;
      }
      DeliverySettlement.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.editObj.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    var validateTitle = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("settlement.title")]))
        );
        return;
      }
      DeliverySettlement.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    return {
      searchForm: {
        title: null,
        clientId: null,
      },
      sorter: {
        sortBy: "deliverySettlements_id",
        sortIndicator: "desc",
      },
      courierTenants: [],
      //
      currentRowIdx: null,
      currentRowId: null,
      showDF: false,
      row: null,
      // 编辑
      validateTitleEdit: validateTitleEdit,
      editDF: false,
      editObj: {
        title: null,
      },
      editDoing: false,
      // 新增
      validateTitle: validateTitle,
      addDF: false,
      addObj: {
        title: null,
        sender: null,
        _date: null,
        tracking: null,
      },
      addDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        settleType: "carry",
      };
    },
  },

  created() {
    const self = this;
  },
  methods: {
    add() {
      const self = this;
      self.addObj.title = Util.serialNoSimple();
      self.addObj.sender = null;
      self.addObj._date = null;
      self.addDoing = false;
      self.addDF = true;
    },
    blurSender() {
      const self = this;
      if (this.addObj.sender != null && this.addObj.sender != "") {
        self.addObj.title = this.addObj.sender + Util.serialNoSimple();
      }
    },
    addSubmit() {
      const self = this;
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          const obj = {
            sender: this.addObj.sender,
            deliverAtStartAt:
              Util.formatDate(this.addObj._date[0]) + " 00:00:00",
            deliverAtEndAt: Util.formatDate(this.addObj._date[1]) + " 23:59:59",
            deliverType: "carry",
          };
          self.addDoing = true;
          Delivery.unSettle(Util.deleteObjValueIsNull(obj)).then(function (
            res
          ) {
            if (res.status === 200) {
              self.addDoing = false;
              if (res.data.length === 0) {
                self.$message({
                  message: self.$t("text.noData"),
                  type: "warning",
                });
              } else {
                self.$router.push({
                  name: "fnReportsDeliverSettlementsCarryNew",
                  params: { title: self.addObj.title },
                  query: Util.deleteObjValueIsNull(obj),
                });
                self.addDF = false;
              }
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 收款完毕
    confirmPayOff(row, rowIndex) {
      const self = this;
      if (confirm(this.$t("action.paymentOff"))) {
        DeliverySettlement.payOff(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("action.paymentOff"),
              type: "success",
            });
            self.records[rowIndex].payoffAt = Util.formatDate(new Date());
          } else {
            self.sysError();
          }
        });
      }
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        DeliverySettlement.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editObj.title = row.title;
      self.editObj.amount = row.amount;
      self.editDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          DeliverySettlement.update(this.row.id, self.editObj).then(function (
            res
          ) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].title = self.editObj.title;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    //-----
    dataProvider(params) {
      return DeliverySettlement.search(params);
    },
  },
};
</script>
